export default "__VITE_ASSET__C4pwReuY__"